import { atom } from 'recoil';

import { Atoms } from '@store/constants';

export type UploadFiles = {
  name: string;
  progressPercentage: number;
};

export const uploadFilesAtom = atom({
  key: Atoms.uploadFiles,
  default: [] as UploadFiles[],
});
